import styled from 'styled-components';
import { TextButton } from '@finect/tabular-core/TextButton';
import { getFont } from '@finect/tabular-utils/getFont';
import { ModalHeader, ModalTitle, ModalBody } from '../../../../Modal';
export var Button = styled(TextButton).withConfig({
  displayName: "partials__Button",
  componentId: "sc-1xkg8j4-0"
})(["font-weight:500;", ";"], getFont(-1, 'compact'));
export var ModalBodyBlock = styled(ModalBody).withConfig({
  displayName: "partials__ModalBodyBlock",
  componentId: "sc-1xkg8j4-1"
})(["overflow-x:scroll;max-height:700px;padding-left:24px;"]);
export var ModalHeaderWithIcon = styled(ModalHeader).withConfig({
  displayName: "partials__ModalHeaderWithIcon",
  componentId: "sc-1xkg8j4-2"
})(["padding-top:24px;", "{margin-top:0;}svg{color:", ";}"], ModalTitle, function (_ref) {
  var theme = _ref.theme;
  return theme.colors.primary;
});
export var Content = styled.div.withConfig({
  displayName: "partials__Content",
  componentId: "sc-1xkg8j4-3"
})(["padding-bottom:24px;p{margin-left:auto;margin-right:auto;}"]);